import Axios from "../helper/appConfig";

export async function getCoupon() {
  const today = new Date();

  const postData = {
    search: [
      {
        searchfield: "status",
        searchvalue: "active",
        criteria: "eq",
        datatype: "text",
      },
      {
        searchfield: "startdate",
        searchvalue: today,
        criteria: "lte",
        datatype: "Date",
        cond: "and",
      },
      {
        searchfield: "enddate",
        searchvalue: today,
        criteria: "gte",
        datatype: "Date",
        cond: "and",
      },
      {
        searchfield: "availcoupon",
        searchvalue: 0,
        criteria: "gt",
        datatype: "number",
      },
    ],
    viewname: "couponviews",
    searchtext: "", // PATCH TO SKIP PAGING
  };

  return Axios.post("api/coupons/filter", postData);
}
